import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { DatePipe, CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCarouselModule } from 'ng-mat-carousel';
import { UploadDocumentsComponent } from './custom-component/upload-documents/upload-documents.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgRatingBarModule } from 'ng-rating-bar';
import { MatNativeDateModule } from '@angular/material/core';
// or
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SpinnerComponent } from './shared/components/spinner.component';
import { LoadingInterceptor } from './core/auth/loading.interceptor';

// import { OpsTaskTrackerComponent } from './modules/admin/dashboards/ops-task-tracker/ops-task-tracker.component';

// import { OnboardingTourComponent } from './custom-component/onboarding-tour/onboarding-tour.component';
// import { BackdropComponent } from './custom-component/backdrop/backdrop.component';

// import { ConfirmationDialogComponent } from './modules/admin/ui/confirmation-dialog/confirmation-dialog.component'; 
// import { ConfirmationDialogService } from './modules/admin/ui/confirmation-dialog/confirmation-dialog.service';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { TypeAndSearchModule } from './custom-component/type-and-search/type-and-search.module';



const NodeCache = require("node-cache");
export const appCache = new NodeCache();

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
    // , enableTracing: true
};


@NgModule({
    declarations: [
        AppComponent,
        UploadDocumentsComponent,
        SpinnerComponent,


    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        MatDialogModule,
        CommonModule,
        // Fuse, FuseConfig & FuseMockAPI
        NgRatingBarModule,
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        //moment add for datepicker
        MatNativeDateModule,
        MatMomentDateModule,
        MatDatepickerModule,

        // Core module of your application
        CoreModule,
        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
        MatCarouselModule.forRoot(),
        MatSnackBarModule,
        NgxDocViewerModule,
        // TypeAndSearchModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000, panelClass: ['mat-toolbar', 'mat-primary'] } },
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        }

        // ConfirmationDialogService
    ],
    // entryComponents: [ ConfirmationDialogComponent ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
